export default __webpack_public_path__ + "static/media/timeline_4.573d3197.svg";